import logoIcon from "@/assets/logo/chouchud-logo.png";

/**
 * Brand wordmark (docs/design/design_handoff_chouchud_marketplace_soft_lavender/
 * ChouchudDesignSystem-LavenderFull-standalone.html "Logo" section) — same
 * treatment as apps/web's Logo, kept as a separate copy since the two apps
 * don't share a component package. Wordmark color #8E7CC3 is fixed
 * regardless of theme, per the design system's logo spec.
 */
export function Logo({
  iconSize = 26,
  textClassName = "text-base",
}: {
  iconSize?: number;
  textClassName?: string;
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <img src={logoIcon} alt="" width={iconSize} height={iconSize} className="shrink-0" />
      <span className={`font-heading font-extrabold lowercase ${textClassName}`} style={{ color: "#8E7CC3" }}>
        chouchud
      </span>
    </span>
  );
}
